import styled from 'styled-components';
import Colors from '../../constants/Colors';

const CalculatorBg = styled.div`
  display: grid;
  height: 100%;
  overflow-x: scroll;
  background: ${Colors.darkBlueGray};
`;

export { CalculatorBg };



// WEBPACK FOOTER //
// ./src/components/Calculator/CalculatorUI.tsx